import React, { useEffect, useState } from 'react';
import { ConfigProvider, notification } from 'antd';
import './i18n';
import Parameters from 'shared/parameters';

import de_DE from 'antd/es/locale/de_DE';
import en_US from 'antd/es/locale/en_US';

// Router
import ProtectedRoute from 'shared/components/ProtectedRoute';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AuthProvider } from 'shared/contexts/AuthContext';


// Views
import Layout from 'views/Layout';
import Login from 'views/login/Login';


import 'antd/dist/antd.css';
import './App.scss';
import Signup from 'shared/view/login/Signup/Signup';
import API_SERVICE from 'shared/services/api-service';
import LoaderOverlay from 'shared/components/LoaderOverlay';
import ClosedProtectedRoute from 'shared/components/ClosedProtectedRoute';
import LayoutClosed from './views/LayoutClosed';
import LayoutSuperAdmin from './views/LayoutSuperAdmin';
import LayoutAdmin from './views/LayoutAdmin';
import ResetPasswordPage from './views/ResetPassword/ResetPassword';
import {useTranslation} from "react-i18next";
import InsTructorRegister from 'shared/view/login/Signup/InstructorRegister';
import ScrollToTop from 'ScrollToTop';

function App() {
    const [loading, setLoading] = useState(true);
    const [theme, setTheme] = useState('');
    const lang = localStorage.getItem('language') || Parameters.DefaultLang;
    const locale = lang === 'de' ? de_DE : en_US;
    const {i18n} = useTranslation();
    useEffect(() => {
        if (Parameters.Mode === 'CLIENT' || Parameters.Mode === 'ADMIN') {
            API_SERVICE.fetchSettings().then((settings) => {
                localStorage.setItem('settings', JSON.stringify(settings.data.data));
                setLoading(false);
                if (settings.data.data && settings.data.data.theme_config) {
                    setTheme(JSON.parse(settings.data.data.theme_config).color);
                }
            }).catch((e) => {
                notification.error({
                    message: API_SERVICE.handleErrors(e),
                });
            });
        } else {
            setLoading(false);
        }
      i18n.changeLanguage(lang)
    }, []);
    return (
       <div className={`${theme}`}>
           <ConfigProvider locale={locale}>
               <AuthProvider>
                   {loading ? <LoaderOverlay size={'large'} /> : <Router>
                   <ScrollToTop />
                       {
                           Parameters.Mode === 'CLIENT' && <Switch>
                               <Route exact path='/login' component={Login} />
                               <Route exact path='/register' component={Signup} />
                               <Route exact path='/instructor-register' component={InsTructorRegister} />
                               <Route exact path='/reset-password' component={ResetPasswordPage} />
                               <Route exact path='/reset-password/:token' component={ResetPasswordPage} />
                               <ProtectedRoute path='/my' component={Layout} />
                               <ClosedProtectedRoute path='/' component={LayoutClosed} />
                           </Switch>
                       }
                       {
                           Parameters.Mode === 'ADMIN' && <Switch>
                               <Route exact path='/login' component={Login} />
                               <Route exact path='/register' component={Signup} />
                               {/*<Route exact path="/confirm-email" component={ConfirmEmail} />*/}
                               {/*<Route exact path="/reset-password-request" component={ResetPasswordRequest} />*/}
                               <ClosedProtectedRoute path='/' component={LayoutAdmin} />
                           </Switch>
                       }
                       {
                           Parameters.Mode === 'SUPER_ADMIN' && <Switch>
                               <Route exact path='/login' component={Login} />
                               <Route exact path='/register' component={Signup} />
                               <Route exact path='/contact' component={Signup} />
                               <Route exact path='/privacy-policy' component={Signup} />
                               <Route exact path='/terms-of-use' component={Signup} />
                               <Route exact path='/about' component={Signup} />
                               <Route exact path='/copyright' component={Signup} />
                               {/*<Route exact path="/confirm-email" component={ConfirmEmail} />*/}
                               {/*<Route exact path="/reset-password-request" component={ResetPasswordRequest} />*/}
                               <ProtectedRoute path='/' component={LayoutSuperAdmin} />
                           </Switch>
                       }
                   </Router>}
               </AuthProvider>
           </ConfigProvider>
       </div>

    );
}

export default App;
